import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-gray-200 last:border-0" data-id="element-14">
      <button onClick={onClick} className="w-full py-4 px-6 flex items-center justify-between text-left focus:outline-none hover:bg-gray-50 transition-colors" data-id="element-15">
        <span className="font-bold text-gray-800 text-lg" data-id="element-16">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-[#10B981]" data-id="element-17" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-18" />}
      </button>
      <AnimatePresence data-id="element-19">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-20">
            <div className="px-6 pb-6 text-gray-600 leading-relaxed" data-id="element-21">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
interface AccordionProps {
  items: {
    question: string;
    answer: string;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100" data-id="element-22">
      {items.map((item, index) => <AccordionItem key={index} question={item.question} answer={item.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-23" />)}
    </div>;
}